var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo, useState, forwardRef, } from 'react';
import { DateTime } from 'luxon';
import { DayRangeView, DayView, MonthView, YearView } from './Views';
import Header from './Header';
import { Footer, FooterRange } from './Footer';
import { CalendarBase } from './styled';
import CalendarContext from './CalendarContext';
import { getInitialDate } from './helpers/getInitialDate';
function Calendar(_a, ref) {
    var _b;
    var { min, max, value, range: rangeProp, onRangeChange, onChange, disabledDate = () => false, locale = 'en', clearLabel = locale === 'no' ? 'Nullstill' : 'Clear', clearable = false, selectRange = false } = _a, props = __rest(_a, ["min", "max", "value", "range", "onRangeChange", "onChange", "disabledDate", "locale", "clearLabel", "clearable", "selectRange"]);
    const [view, setView] = useState('day');
    const [range, setRange] = useState(rangeProp !== null && rangeProp !== void 0 ? rangeProp : [null, null]);
    const initialDate = getInitialDate(selectRange ? (_b = range[1]) !== null && _b !== void 0 ? _b : range[0] : value, min);
    const [date, setDate] = useState(DateTime.fromJSDate(initialDate).setLocale(locale).startOf('day'));
    const context = useMemo(() => ({
        date,
        setDate,
        view,
        setView,
        value,
        onChange: onChange !== null && onChange !== void 0 ? onChange : (() => { }),
        max,
        min,
        disabledDate,
        locale,
        clearable,
        clearLabel,
        range,
        selectRange,
        onRangeChange: onRangeChange !== null && onRangeChange !== void 0 ? onRangeChange : (() => { }),
        setRange,
    }), [
        date,
        setDate,
        view,
        setView,
        value,
        onChange,
        range,
        onRangeChange,
        selectRange,
        max,
        min,
        disabledDate,
        locale,
        clearable,
        clearLabel,
    ]);
    return (React.createElement(CalendarBase, Object.assign({ ref: ref }, props),
        React.createElement(CalendarContext.Provider, { value: context },
            React.createElement(Header, null),
            view === 'day' && (selectRange ? React.createElement(DayRangeView, null) : React.createElement(DayView, null)),
            view === 'month' && React.createElement(MonthView, null),
            view === 'year' && React.createElement(YearView, null),
            selectRange ? React.createElement(FooterRange, null) : React.createElement(Footer, null))));
}
export default forwardRef(Calendar);
